// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-ac61a096] .el-button {\n  border: none;\n}\n[data-v-ac61a096] .el-form-item__label,[data-v-ac61a096] .el-table--border .el-table__cell .cell {\n  color: #333333;\n  font-weight: 400;\n  font-size: 14px;\n}\n.page-title[data-v-ac61a096] {\n  margin-bottom: 0 !important;\n}\n.page-title h2[data-v-ac61a096] {\n    border-bottom: 2px solid #d1d1d1 !important;\n}\n.process-details .content .el-form .el-form-item[data-v-ac61a096]:nth-child(6) {\n  margin-bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
